import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SubtleBadge from '../../../../../components/common/SubtleBadge'
import { formatValue } from '../../../../../utils/utils'

export interface SingleValueBadgeProps {
  value?: any
  unit?: string
  color?: string
  icon?: 'caret-up' | 'caret-down' | 'minus'
}

const SingleValueBadge = ({
  value,
  unit,
  color,
  icon,
}: SingleValueBadgeProps) => {
  if (value === undefined || value === null) {
    return null
  }
  return (
    <SubtleBadge
      pill
      style={{
        backgroundColor: color,
      }}
    >
      {icon && <FontAwesomeIcon icon={icon} className={'me-1'} />}
      {formatValue(value, 2, unit, false)}
    </SubtleBadge>
  )
}

export default SingleValueBadge
